const BMIBarUI = [
  {
    state: 'Under',
    bgColor: '#ffc412',
    max: 18.5,
    range: 18.5,
  },
  {
    state: 'Normal',
    bgColor: '#13cdc4',
    max: 24.9,
    range: 6.4,
  },
  {
    state: 'Over',
    bgColor: '#1288a9',
    max: 29.9,
    range: 5,
  },
  {
    state: 'Obese',
    bgColor: '#eb4c68',
    max: 39.9,
    range: 10,
  },
];

const BMIBar = () => {
  const BMIBarValue = [
    {
      value: 18.5,
    },
    {
      value: 24.9,
    },
    {
      value: 29.9,
    },
  ];

  return (
    <div className='w-full text-xs font-bold text-white'>
      <div className='flex items-center justify-center w-full'>
        {BMIBarUI.map((stage, i) => (
          <div
            key={stage.state}
            className={`relative py-1 w-1/4 text-center ${
              i === 0 ? 'rounded-l-full' : i === 3 ? 'rounded-r-full' : ''
            }`}
            style={{
              backgroundColor: stage.bgColor,
            }}
          >
            <div className='text-white'>{stage.state}</div>
          </div>
        ))}
      </div>
      <div className='flex items-center justify-evenly w-full'>
        {BMIBarValue.map((stage) => (
          <div
            key={stage.value}
            className='text-center'
          >
            <div className=''>{stage.value}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default BMIBar;
